// External libraries
import React from 'react';
import { object, string } from 'prop-types';

// internal modules
import {
  Amount,
  CurrencyCode,
  Group,
  ItemDetails,
  LineClamp,
  Row,
} from './StyledComponents';

const CartDescription = ({ description }) => (
  <Group>
    <Row>
      <p>{description}</p>
    </Row>
  </Group>
);

CartDescription.propTypes = {
  description: string,
};

const CartItem = ({ currencyCode, item }) => {
  const { description, details, name, quantity, unitPrice } = item;

  return (
    <Group>
      <Row>
        <LineClamp>
          {quantity} &#215; {name}
        </LineClamp>
        <Amount>
          {unitPrice}
          <CurrencyCode>{currencyCode}</CurrencyCode>
        </Amount>
      </Row>
      {description && (
        <Row>
          <LineClamp>{description}</LineClamp>
        </Row>
      )}
      {details && (
        <ItemDetails>
          {details.map(([key, value], detailIdx) => (
            <dl key={detailIdx}>
              <dt>{key}: </dt>
              <dd>{value}</dd>
            </dl>
          ))}
        </ItemDetails>
      )}
    </Group>
  );
};

CartItem.propTypes = {
  currencyCode: string,
  item: object,
};

const LineAmount = ({ amount, currencyCode, description }) => {
  const formatDescription = description.toLowerCase();
  const descriptionClassName = formatDescription === 'total' ? 'total' : '';
  return (
    <Row>
      <p className={descriptionClassName}>{description}</p>
      <Amount className={descriptionClassName}>
        {amount}
        <CurrencyCode>{currencyCode}</CurrencyCode>
      </Amount>
    </Row>
  );
};

LineAmount.propTypes = {
  amount: string,
  currencyCode: string,
  description: string,
};

export { CartDescription, CartItem, LineAmount };
